<template>
    <div class="row">
        <div class="col">
            <div class="card card-small mb-4">
                <div class="card-header border-bottom">
                    <div class="float-left">
                        <h6 class="m-0"></h6>
                    </div>
                    <div v-if="pagination.TotalItems > 0" class="float-right">
                        <h6 class="m-0">
                            {{ pagination.TotalItems | number }}
                            {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                        </h6>
                    </div>
                </div>
                <div class="card-body p-0 pb-3 text-center">
                    <loader :is-loading="loadingList"></loader>
                    <table class="table mb-0" v-if="!loadingList">
                        <thead class="bg-s2p-gray-light">
                            <tr>
                                <th scope="col" class="border-0"></th>
                                <th scope="col" class="border-0 text-left">Banco</th>
                                <th scope="col" class="border-0 text-left">Tipo de Conta</th>
                                <th scope="col" class="border-0">Agência</th>
                                <th scope="col" class="border-0">Conta</th>
                                <th scope="col" class="border-0">Código Contabilidade</th>
                                <th scope="col" class="border-0"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(line, index) in lines" :key="index">
                                <td>
                                    <!-- <img height="32" width="32" style="filter: grayscale(0.5)" :src="require( `@/assets/images/${line.Bank.Code}.svg`)" /> -->


                                    <img v-if="line.Bank.Code == '001'" src="@/assets/images/bank_0001.png"
                                        height="32px" width="32px" class="logo" />
                                    <img v-if="line.Bank.Code == '033'" src="@/assets/images/bank_0033.png"
                                        height="32px" width="32px" class="logo" />
                                    <img v-if="line.Bank.Code == '041'" src="@/assets/images/bank_0041.png"
                                        height="32px" width="32px" class="logo" />
                                    <img v-if="line.Bank.Code == '104'" src="@/assets/images/bank_0104.png"
                                        height="32px" width="32px" class="logo" />
                                    <img v-if="line.Bank.Code == '237'" src="@/assets/images/bank_0237.jpg"
                                        height="32px" width="32px" class="logo" />
                                    <img v-if="line.Bank.Code == '341'" src="@/assets/images/bank_0341.png"
                                        height="32px" width="32px" class="logo" />
                                    <img v-if="line.Bank.Code == '422'" src="@/assets/images/bank_0422.png"
                                        height="32px" width="32px" class="logo" />
                                    <img v-if="line.Bank.Code == '745'" src="@/assets/images/bank_0745.png"
                                        height="32px" width="32px" class="logo" />
                                    <img v-if="line.Bank.Code == '748'" src="@/assets/images/bank_0748.png"
                                        height="32px" width="32px" class="logo" />



                                </td>
                                <td class="text-left" style="vertical-align: middle;">{{ line.Bank.Name }}</td>
                                <td class="text-left" style="vertical-align: middle;">{{ line.AccountType.Name }}</td>
                                <td style="vertical-align: middle;">{{ line.BankAgency }}{{ line.BankAgencyDigit.length
                                    >
                                    0 ?'-' + line.BankAgencyDigit : ''}}</td>
                                <td style="vertical-align: middle;">{{ line.BankAccount }}{{
                                    line.BankAccountDigit.length
                                        > 0 ? '-' + line.BankAccountDigit : ''}}</td>

                                <td style="vertical-align: middle;">
                                    {{ line.AccoutingCode ? line.AccoutingCode : '-' }}
                                </td>
                                          
                                          

                                <td style="vertical-align: middle;">
                                    <div class="dropdown">
                                        <button class="btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            Opções
                                        </button>
                                        <div class="dropdown-menu" arial-labelledby="dropdownMenuButton">
                                            <a class="dropdown-item" href="#"
                                                v-on:click="OpenField($event, index, false)">
                                                <i class="fas fa-highlighter mr-2"></i> Editar

                                            </a>

                                            <a class="dropdown-item" href="#"
                                                v-on:click="OpenField($event, index, true)">
                                                <i class="fas fa-eye mr-2"></i> Visualizar

                                            </a>

                                            <a class="dropdown-item" href="#"   
                                                v-on:click="ConfirmDelete($event, line)">
                                                <i class="fas fa-trash-alt mr-2"></i> Desativar

                                            </a>

                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="
                                lines == undefined || lines == null || lines.length == 0
                            ">
                                <td colspan="6">Sem registros</td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="col-12 border-top">
                        <div class="pagination-nav">
                            <b-pagination class="float-right" v-model="pagination.PageNumber"
                                :total-rows="pagination.TotalItems" :per-page="pagination.RowsPerPage"
                                aria-controls="my-table"></b-pagination>
                            <div class="float-left">
                                <d-select size="sm" v-model="pagination.RowsPerPage">
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="30">30</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                    <option value="500">500</option>
                                </d-select>
                            </div>
                        </div>
                    </div>
                </div>
                <a v-if="$isAuthorize('UserInternal', 'Delete')" href="#" class="btn-float success" v-b-tooltip.hover
                    title="Nova Conta" v-on:click="OpenField($event, null, null)">
                    <i class="fa fa-plus"></i>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TableListBA",
    props: {
        lines: {
            type: Array
        },
        pagination: {
            type: Object
        },
        loadingList: {
            type: Boolean
        }
    },
    watch: {
        pagination() {
            this.$emit('update:pagination', pagination);
        },
        "pagination.PageNumber"() {
            this.$emit("List");
        },
        "pagination.RowsPerPage"() {
            this.$emit("List");
        }
    },
    methods: {

        OpenField(e, i, view) {
            this.$emit("Open", e, i, view);
        },
        ConfirmDelete(e, line) { 
            this.$emit("Delete",e, line.Id);
        }
    }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/pages/TableListBA.vue